export default __webpack_public_path__ + "static/ukraine-analysen-67a0cc79a500df07dda58753c5348675.png";